import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoDyo: CultureInfo = {
  name: 'dyo',
  displayName: 'joola',
  iso3LanguageCode: 'dyo',
  iso2LanguageCode: 'dyo',
  ietfLanguageTag: 'dyo',
  parent: null
};
